var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGileadRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 7.534C9.10079 8.35276 8.85868 9.15335 8.40429 9.83445C7.94991 10.5156 7.30368 11.0466 6.5474 11.3602C5.79111 11.6739 4.95877 11.7562 4.1557 11.5967C3.35264 11.4371 2.61495 11.043 2.036 10.464C1.45705 9.88505 1.06286 9.14737 0.90332 8.3443C0.743782 7.54124 0.826065 6.70889 1.13976 5.95261C1.45345 5.19632 1.98444 4.5501 2.66555 4.09571C3.34665 3.64133 4.14724 3.39921 4.966 3.4H7.524L6.04 4.88L6.62 5.465L9.1 2.983L6.621 0.5L6.041 1.085L7.525 2.569H4.966C3.98382 2.569 3.02369 2.86025 2.20704 3.40592C1.39039 3.95159 0.753881 4.72718 0.378016 5.63459C0.00215155 6.54201 -0.0961916 7.54051 0.0954226 8.50382C0.287037 9.46713 0.760003 10.352 1.45451 11.0465C2.14902 11.741 3.03387 12.214 3.99718 12.4056C4.96049 12.5972 5.95899 12.4989 6.86641 12.123C7.77383 11.7471 8.54941 11.1106 9.09508 10.294C9.64075 9.47731 9.932 8.51718 9.932 7.535L9.1 7.534Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGileadRefreshIcon);
export default __webpack_public_path__ + "static/media/gilead-refresh-icon.e0b685feaeda2ef78c69026659d4a8b7.svg";
export { ForwardRef as ReactComponent };